module.exports = __webpack_public_path__ + "static/media/taizu_thumb_even_big.15decf9b.webp";